var a={loadingIndicator:"lds-loading-indicator"};export{a as default};
